module.exports = __webpack_public_path__ + "static/media/avatar_gradios_negativo.696441ae.png";